export enum ORGANISATION_FEATURE_FLAGS {
  USE_V2_AGGREGATES = "USE_V2_AGGREGATES",
  DISABLE_PALACE_PROPERTY_IMPORT = "DISABLE_PALACE_PROPERTY_IMPORT",
  ENABLE_VICTRON_ENERGY_INTEGRATION = "ENABLE_VICTRON_ENERGY_INTEGRATION",
  ENABLE_SSO_INTEGRATION = "ENABLE_SSO_INTEGRATION",
  /**
   * Show the "API keys" section on Organisation Settings and let owners/admins create keys. The API
   * enforces the same flag on create, rotate and every request made with a key, so this is not a
   * cosmetic gate. Same polarity as ENABLE_SSO_INTEGRATION: a missing row means off.
   */
  ENABLE_API_KEY_INTEGRATION = "ENABLE_API_KEY_INTEGRATION",
  TENANT_BILLING = "TENANT_BILLING",
  /**
   * Hide the Airborne Index page — its sidebar entry and its routes.
   *
   * Named for what it HIDES, so an organisation with no row keeps the page. A flag named
   * for the feature would have to be set on every existing organisation to preserve
   * today's behaviour, and the one nobody remembered would lose the page silently.
   */
  HIDE_AIRBORNE_INDEX = "HIDE_AIRBORNE_INDEX",
  /**
   * Hide every energy-derived view on the Portfolio dashboard, and stop asking for the
   * data behind them.
   *
   * Same polarity as HIDE_AIRBORNE_INDEX and the same reason. Covers the four insights
   * that read from `energyInsights` (see ENERGY_PORTFOLIO_INSIGHTS) and the two requests
   * that fetch it — the org power readings and the energy-by-tag roll-up, which are the
   * two slowest things the page does. The dashboard then opens on Mould Risk.
   */
  HIDE_ENERGY_INSIGHTS = "HIDE_ENERGY_INSIGHTS",
  /**
   * Portfolio energy from the daily rollup (org-scale PR 5.2): GET
   * experience/v1/property/portfolio instead of the organisation-power fan-out.
   *
   * Named for what it turns ON, against this file's HIDE_ convention, because the API owns
   * the name (OrganisationFeatureFlagKeys.OrgRollupReads gates the endpoint). The
   * convention's worry does not apply: a missing row means off, and off is today's page.
   */
  ORG_ROLLUP_READS = "ORG_ROLLUP_READS",
}
